import React from 'react';
import { IIconProps } from './utils';

export const ChevronDown = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.5 11.25L14.1161 17.8661C14.6043 18.3543 15.3957 18.3543 15.8839 17.8661L22.5 11.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
